import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { RubricService } from './rubric.service';


export const ngxRubricServiceModule = angular.module('ngxRubricServiceModule', [])
	.factory('ngxRubricService', downgradeInjectable(RubricService) as any)
	.name;
